import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { initWebVitals, createWebVitalsReporter } from '@/utils/webVitals';
import '@/styles/globals.css';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>
);

// Initialize Web Vitals tracking after the app mounts
// Reports to console in development, can be configured to send to analytics in production
initWebVitals(
  createWebVitalsReporter({
    // Enable debug logging in development
    debug: import.meta.env.DEV,
    // Uncomment and set endpoint to send metrics to your analytics service
    // analyticsEndpoint: '/api/analytics/web-vitals',
  })
);
